import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Grid, TableCell, TableRow } from "@mui/material";
import { Colors } from "../../constants/Colors";
import Card from "../../components/Card";
import CustomTable from "../../components/Table";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../../services/api-request";
import { useForm } from "react-hook-form";
import CustomInput from "../../components/Input";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Pagination from "../../components/Pagination";
import CustomDialog from "../../components/ConfirmationModal";
import { useAppContext } from "../../context/AppContext";
import CustomButton from "../../components/Button";
import { downloadFile } from "../../utilities/exportToCsv";
import AddEditUser from "./add-edit-user";

const tableHeaders = [
  {
    id: 1,
    title: "S.No",
  },
  {
    id: 1,
    title: "ID",
  },
  {
    id: 2,
    title: "Name",
  },
  {
    id: 3,
    title: "Mobile",
  },
  {
    id: 4,
    title: "State",
  },
  {
    id: 5,
    title: "Circle",
  },
  {
    id: 6,
    title: "Regional",
  },
  {
    id: 7,
    title: "Branch",
  },
  {
    id: 8,
    title: "Created On",
  },
];

const Users = () => {
  const { user = {} } = useAppContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const [userList, setUserList] = useState({});
  const [currentFarmerState, setCurrentFarmerState] = useState({});

  const [openUserModal, setOpenUserModal] = useState({
    open: false,
    data: [],
  });

  const [mithunAceFilters, setMithunAceFilters] = useState({});

  const [selectedValue, setSelectedValue] = useState({});
  const [userAnimalsCSV, setUserAnimalsCSV] = useState({
    data: [],
    loader: false,
  });

  const limit = 10;
  const [skip, setSkip] = useState(0);

  const [filters, setFilters] = useState({
    search: "",
    state_id: "",
    district_id: "",
    mandal_id: "",
    village_id: "",
  });

  const handleSearchTextChange = (e) => {
    const selectedValue = e.target.value;
    setFilters((prev) => ({
      ...prev,
      search: selectedValue,
    }));
  };

  useEffect(() => {
    getUsersByType(
      filters,
      skip,
      selectedValue,
    );
  }, [filters, skip, selectedValue]);

  const getUsersByType = useCallback(
    (filters, skip, selectedValue) => {
      let url = `bank/get-branch-managers`;
      const aceFilters = {
        limit: limit,
        skip: skip,
        filters: filters,
        sort_field: "_id",
        sort_order: "desc",
        search_fields: ["name", "mobile", "user_id"],
      };

      apiRequest({
        url,
        data: aceFilters,
        method: "POST",
      })
        .then((res) => {
          if (res) {
            const modifiedUserList = {
              ...res,
              data: res?.data?.map((user) => ({
                user_id: user?.user_id,
                name: user?.name,
                mobile: user?.mobile,
                stateId: user?.state_id,
                circle_id: user?.circle_id,
                regional_id: user?.regional_id,
                branch_id: user?.branch_id,
                created_on: user?.created_on,
                stateName: user?.state_name ? user?.state_name : "",
                circle: user?.circle_name ? `${user?.circle_name}` : "",
                regional: user?.regional_name ? `${user?.regional_name}` : "",
                branch: user?.branch_name ? `${user?.branch_name}` : "",
              })),
              totalCount: res.total_count,
            };
            setUserList(modifiedUserList);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    []
  );

  const handlePageChange = (pageNumber) => {
    const newSkip = (pageNumber - 1) * limit;
    setSkip(newSkip);
  };

  const TableDataUi = () => {
    return userList?.data?.length ? (
      userList?.data?.map((row, index) => (
        <TableRow
          key={row.id}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
          <TableCell>
            <Typography
              fontFamily={"Poppins-Medium"}
              color={Colors.headerColor}
              fontSize={13}
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {skip + index + 1}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Medium"}
              color={Colors.headerColor}
              fontSize={13}
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {row.user_id}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.name}
            </Typography>
          </TableCell>
          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.mobile}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.stateName}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.circle}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.regional}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Regular"}
              color={Colors.textColor}
              fontSize={12}
            >
              {row.branch}
            </Typography>
          </TableCell>

          <TableCell>
            <Typography
              fontFamily={"Poppins-Medium"}
              color={Colors.headerColor}
              fontSize={13}
            >
              {row.created_on}
            </Typography>
          </TableCell>
        </TableRow>
      ))
    ) : (
      <>
        <TableRow
          key={"row.id"}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          rowS
        >
          <TableCell colSpan={8} align="center">
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Typography>No Data Available</Typography>
            </Box>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const onClickModalClose = () => {
    setIsModalOpen(false);
    setCurrentFarmerState({});
  };

  const handleAceFilterChange = (filters) => {
    getUsersByType(filters, skip);
  };

  useEffect(() => {
    let headers = [
      "Id,Name,Mobile,State,Circle,Regional,Branch,Created On",
    ];

    let partnersCSV;
    if (Array.isArray(userAnimalsCSV.data) && userAnimalsCSV.data.length > 0) {
      partnersCSV = userAnimalsCSV.data?.reduce((acc, user, index) => {
        acc.push(
          [
            user?.user_id,
            user?.name,
            user?.mobile,
            user?.state_name,
            user?.circle_name,
            user?.regional_name,
            user?.branch_name,
            user?.created_on,
          ].join(",")
        );
        return acc;
      }, []);

      downloadFile({
        data: [...headers, ...partnersCSV].join("\n"),
        fileName: "Branch Managers.csv",
        fileType: "text/csv",
      });
    }
  }, [userAnimalsCSV]);

  const exportToCsv = () => {
    mithunAceFilters.skip = 0
    mithunAceFilters.limit = 10000000
    mithunAceFilters.filters = filters
    apiRequest({
      url: `bank/get-branch-managers`,
      method: "POST",
      data: mithunAceFilters
    })
      .then((res) => {
        setUserAnimalsCSV({ data: res?.data, loader: true });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Box>
      <CustomDialog
        open={openUserModal.open}
        width={"500px"}
        onClose={() => setOpenUserModal({ open: false })}
        title={"Add Branch Manager"}
      >
        <AddEditUser
          onCancel={() => setOpenUserModal({ open: false })}
          currentState={currentFarmerState}
          isEdit={Boolean(currentFarmerState?.id)}
          getUsersByType={() =>
            getUsersByType(filters, skip, selectedValue)
          }
        />
      </CustomDialog>

      <Grid
        container
        alignItems={"center"}
        gap={"10px"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Typography
            fontFamily={"Poppins-Medium"}
            fontSize={20}
            color={Colors.textColor}
          >
            Branch Manager List
          </Typography>
        </Grid>
        <Grid item spacing={2}>
          <Box display={"flex"} gap={"10px"}>
            <Box>
              <CustomButton
                title={`Export List`}
                handleButtonClick={() => exportToCsv()}
                backgroundColor={Colors.headerColor}
                textColor={Colors.white}
                width={130}
                height={34}
                textFontSize={14}
              />
            </Box>
            <Box>
              <CustomButton
                  title={`Add +`}
                  handleButtonClick={() => setOpenUserModal({ open: true })}
                  backgroundColor={Colors.headerColor}
                  textColor={Colors.white}
                  width={130}
                  height={34}
                  textFontSize={14}
                />
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box mt={2}>
        <Card>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item md={3}>
              <CustomInput
                placeholder={"Search"}
                onChange={(e) => handleSearchTextChange(e)}
                leftIcon={
                  <SearchOutlinedIcon style={{ color: Colors.textColor }} />
                }
              />
            </Grid>
          </Grid>
          <Box mt={2}>
            <CustomTable
              headerData={tableHeaders}
              tableData={[]}
            >
              <TableDataUi setOpenUserModal={setOpenUserModal} />
            </CustomTable>
            <Box mt={2} display={"flex"} justifyContent={"right"}>
              {userList?.totalCount > 1 && (
                <Pagination
                  totalCount={Number(userList?.totalCount)}
                  skip={skip}
                  limit={limit}
                  onPageChange={handlePageChange}
                />
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default Users;
